<template>
  <div class="regional-authorized">
    <div class="regional-authorized-left">
      <Tree :showSwitch='false' title=" " @nodeClick="nodeClick"></Tree>
    </div>
    <div class="regional-authorized-right">
      <TabelSearch :searchConfig="searchConfig" :searchParams="searchParams" @resetCallBack="resetCallBack"
                   @search="setSearchParams"></TabelSearch>
      <Table :width="'100%'" :tableLoading="tableLoading" :tabelButtons="tabelButtons" :templateData="tableTemplateData"
             :tableConfig="tableConfig" :pagination="pagination">
      </Table>
    </div>
    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title" :visible.sync="dialogVisible"
               width="30%" :before-close="handleClose">
      <editForm ref="editForm" :formConfig="formConfig" :ruleForm="ruleForm" :rules="rules"
                :buttonConfig="buttonConfig"></editForm>
    </el-dialog>
    <!-- 配置单位 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title"
               :visible.sync="dialogVisible2" width="30%" :before-close="handleClose2">
      <editForm ref="editForm" :formConfig="formConfig2" :ruleForm="ruleForm2" :rules="rules2"
                :buttonConfig="buttonConfig2"></editForm>
    </el-dialog>
    <!-- 监控平台地址 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title"
               :visible.sync="dialogVisible3" width="30%" :before-close="handleClose3">
      <editForm ref="editForm" :formConfig="formConfig3" :ruleForm="ruleForm3" :rules="rules3"
                :buttonConfig="buttonConfig3"></editForm>
    </el-dialog>

    <!-- 终端权限设置 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="title"
               :visible.sync="dialogVisible4" width="30%" :before-close="handleClose4">
      <editForm ref="editForm" :formConfig="formConfig4" :ruleForm="ruleForm4" :rules="rules4"
                :buttonConfig="buttonConfig4"></editForm>
    </el-dialog>

  </div>
</template>

<script>
import Tree from '../../../../components/Tree/nodeTree';
import Table from "../../../../components/table/table";
import editForm from '../../../../components/edit-form/edit-form';
import TabelSearch from '../../../../components/tabel-search/tabel-search';
import publicApi from '../../../../api-path/public-api';
import {
  districtApi, dahuaApi
} from '../../../../api-path/district-api.js'

export default {
  name: "regional-authorized",
  components: {
    Tree,
    Table,
    editForm,
    TabelSearch
  },
  data() {
    return {
      //search
      searchParams: {
        //是否上报
        report: '',
        open: '', //是否开通
        page: 1,
        size: 15,
        areaId: '0',
        isDown: false, //是否向下查询

      },
      searchConfig: {
        dataName: 'searchParams',
        items: [{
          key: 'report',
          valueType: 'select',
          placeholder: '上报类型',
          option: {
            label: 'name',
            value: 'value'
          },
          data: [{
            name: '可上报',
            value: false
          }, {
            name: '上报终止',
            value: true
          }],
        }, {
          key: 'open',
          valueType: 'select',
          placeholder: '开通类型',
          option: {
            label: 'name',
            value: 'value'
          },
          data: [{
            name: '已开通',
            value: true
          }, {
            name: '未开通',
            value: false
          }],
        }]
      },
      // table
      tableLoading: false,
      tabelButtons: [{
        type: 'add',
        fn: () => {
          let newData = this.ruleForm.parentName;
          let parentId = this.ruleForm.parentId;
          this.ruleForm = {
            parentName: '', //父级区域
            parentId: '',
            name: '', //区域名称
            areaId: '', //区域编码
            nation: '', //经纬度
            longitude: "",
            latitude: "",
            expTimeAuth: '', // 授权到期时间
            thirdCoding: '', //大华组织标识
            // msgLimits: 500, //短信数
            overdueTime: '',
            bgUrl: '',
            bgUrlList: [],
          };
          this.ruleForm.parentName = newData;
          this.ruleForm.parentId = parentId;
          this.formConfig.items[0][0].disabled = false;
          this.dialogVisible = true;
          this.title = '新增'
        }
      },
        // {
        // 	type: 'districtArea',
        // 	fn: () => {
        // 		this.$router.push('/system-settings/district-draw');
        // 	}
        // },
      ],
      tableTemplateData: [],
      tableConfig: {
        checkbox: false,
        index: true,
        checkboxFn: (data) => {
          console.log(data)
        },
        rows: [{
          label: '区域名称',
          prop: 'name',
        }, {
          label: '是否开通',
          activeText: '已开通',
          text: '未开通',
          type: 'button',
          prop: 'open',
          fn: (data, index) => {
            this.$confirm('确认关闭或开通区域状态?', '更新区域状态', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.$http.get(`${districtApi.open}/${data.id}`).then(res => {
                if (res.status === 200) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!',
                  });
                  let dataNew = data;
                  dataNew.open = !data.open;
                  this.tableTemplateData.splice(index, 1, dataNew);
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作',
              });
            });
          }
        }, {
          label: '是否上报',
          activeText: '已上报',
          text: '终止上报',
          type: 'button',
          prop: 'report',
          fn: (data, index) => {
            this.$confirm('确认开启或关闭上报状态?', '更新上报状态', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }).then(() => {
              this.$http.get(`${districtApi.report}/${data.id}`).then(res => {
                if (res.status === 200) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!',
                  });
                  let dataNew = data;
                  dataNew.report = !data.report;
                  this.tableTemplateData.splice(index, 1, dataNew);
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除',
              });
            });
            console.log(data, index);
          }
        }, {
          label: "超时限制",
          prop: 'overdueTime'
        }],
        rowButtons: {
          width: '400px',
          items: [{
            label: '编辑',
            fn: (data) => {
              this.$http.get(`${districtApi.findById}/${data.id}`).then(res => {
                if (res.status === 200) {
                  let newData = JSON.parse(JSON.stringify(res.result));
                  this.ruleForm = newData;
                  this.ruleForm = {
                    parentName: newData.parentName, //父级区域
                    parentId: newData.parentId,
                    name: newData.name, //区域名称
                    areaId: newData.areaId, //区域编码
                    nation: newData.nation, //经纬度
                    longitude: newData.longitude,
                    latitude: newData.latitude,
                    expTimeAuth: newData.expTimeAuth, // 授权到期时间
                    thirdCoding: newData.thirdCoding, //大华组织标识
                    // msgLimits: 500, //短信数
                    overdueTime: newData.overdueTime,
                    bgUrl: newData.bgUrl,
                    bgUrlList: newData.bgUrl ? [{url: newData.bgUrl}] : [],
                    showCode:newData.showCode
                  };
                  this.ruleForm.id = newData.id;
                  this.formConfig.items[0][0].disabled = true;
                  this.title = "编辑";
                  this.dialogVisible = true;
                }
              })
            }
          },
            {
              label: '配置单位',
              type: 'warning',
              fn: (data) => {
                this.$http.get(`${districtApi.findUnitById}/${data.id}`).then(res => {
                  if (res.status === 200) {
                  let newData = JSON.parse(JSON.stringify(res.result));
                  this.ruleForm2 = newData;
                  this.ruleForm2 = {
                    areaId:newData.areaId,
                    bgImg: newData.bgImg,
                    constructionUnit: newData.constructionUnit,
                    domain: newData.domain,
                    id: newData.id,
                    indexImg: newData.indexImg,
                    loginUnit: newData.loginUnit,
                    supportUnit:newData.supportUnit,
                    title: newData.title,
                    titlePinyin: newData.titlePinyin,
                    undertakeUnit: newData.undertakeUnit,
                    bgImgList:newData.bgImg ? [{url: newData.bgImg}] : [],
                    indexImgList:newData.indexImg ? [{url: newData.indexImg}] : []
                  };
                    this.title = '配置单位';
                    this.dialogVisible2 = true;
                  }
                })
              },
            },
            {
              label: '监控平台地址',
              type: 'success',
              fn: (data) => {
                this.title = '监控平台地址';
                this.dialogVisible3 = true;
                this.ruleForm3 = data;
              },
            },
            {
              label: '终端授权',
              type: 'success',
              fn: (data) => {
                /*   获取缓存中数据   开始*/
                let codeData = JSON.parse(localStorage.getItem('codeData'));
                if (codeData == null) {
                  this.$message.error('获取标签内容失败！！');
                  return;
                }
                let arrList = codeData["LIVE_IO_TYPE"];
                if (arrList == null) {
                  this.$message.error('未设置终端类型标签!!');
                  return;
                }
                let item= []
                arrList.forEach(ietm=>{
                  let obj={};
                  obj.label =ietm.itemName;
                  obj.value = ietm.itemValue;
                  item.push(obj)
                });
                this.formConfig4.items[0][0].data=item;
                /*   获取缓存中数据   结束*/

                this.$http.get(`${districtApi.liveIoView}/${data.id}`).then(res => {
                  if (res.status === 200) {
                    let newData = JSON.parse(JSON.stringify(res.result));
                    this.ruleForm4 = newData;
                    this.title = '终端授权';
                    this.dialogVisible4 = true;
                  }
                })
              },
            },
            // {
            // 	label: '查看',
            // 	type: 'success',
            // 	fn: (data) => {
            // 		console.log(data)
            // 	},
            // }
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      //alert-dialog
      title: '',
      dialogVisible: false,
      //dialog-form
      ruleForm: {
        id: '',
        parentName: '', //父级区域
        parentId: '',
        name: '', //区域名称
        areaId: '', //区域编码
        nation: '', //经纬度
        longitude: "",
        latitude: "",
        expTimeAuth: '', // 授权到期时间
        thirdCoding: '', //大华组织标识
        overdueTime: '',//超时限制
        // msgLimits: 0, //短信数
        bgUrl: '',
        bgUrlList: []
      },
      rules: {
        parentName: [{
          required: true,
          message: '请选择父级区域',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入区域名称',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请输入区域编号',
          trigger: 'blur'
        }],
        latitude: [{
          required: true,
          message: '请绑定经纬度',
          trigger: 'blur'
        }],
      },
      buttonConfig: {
        validateAll: ['editForm'],
        buttons: [{
          type: 'save', // 保存
          fn: (data) => {
            let requestData = JSON.parse(JSON.stringify(data));
            requestData.bgUrl = requestData.bgUrlList.length != 0 ? requestData.bgUrlList[0].url : "";
            this.$http.post(districtApi.save, requestData).then(res => {
              if (res.status === 200) {
                this.dialogVisible = false;
                this.setSearchParams();
                this.$message({
                  type: 'success',
                  message: '添加成功！',
                });
              }
            })
          },
        }, {
          type: 'back', // 返回
          fn: () => {
            this.dialogVisible = false;
          }
        },]
      },
      formConfig: {
        ref: 'mapform',
        disabled: false,
        items: [
          [{
            valueType: 'tree-selected', // 类型
            label: '父级区域',
            key: 'parentName', // 数据名称
            prop: 'parentName', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            disabled: false,
            placeholder: '请选择所属辖区', // 提示信息
            fn: (data) => { //选择的值
              this.ruleForm.parentName = data.name;
              this.ruleForm.parentId = data.id;
            }
          }],
          [{
            valueType: 'input', // 类型
            label: '名称',
            key: 'name', // 数据名称
            prop: 'name', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '50%',
            maxlength: 50,
            placeholder: '区域名称', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '国标',
            key: 'areaId', // 数据名称
            prop: 'areaId', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '区域编号', // 提示信息
          }],
          [{
            valueType: 'nautica', // 类型
            label: '地址',
            key: 'nation', // 数据名称
            prop: 'nation', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 30,
            placeholder: '请输入经纬度', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '大华组织标识',
            key: 'thirdCoding', // 数据名称
            prop: 'thirdCoding', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '大华组织标识', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '超时限制',
            key: 'overdueTime', // 数据名称
            prop: 'overdueTime', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            placeholder: '超时限制（小时）', // 提示信息
          }],
            [{
            valueType: 'datetime', // 类型
            label: '授权到期时间',
            key: 'expTimeAuth', // 数据名称
            prop: 'expTimeAuth', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            placeholder: '授权到期时间', // 提示信息
            timeValueFormat: 'yyyy-MM-dd HH:mm:ss',
            fn: (data) => { //选择的值
              console.log('data', data)
            }
          }],
          [
            {
              key: 'showCode',
              label: '监控追溯显示',
              valueType: 'select',
              placeholder: '手机和机顶盒监控追溯开启',
              itemWidth: '100%',
              labelWidth: "140px", // label 宽度
              options: {
                label: 'name',
                value: 'value'
              },
              data: [{
                name: '是',
                value: true
              }, {
                name: '否',
                value: false
              }],
            }
          ],

          // [{
          // 	valueType: 'inputNumber', // 类型
          // 	inputWidth: 'auto',
          // 	label: '短信总条数',
          // 	key: 'msgLimits', // 数据名称
          // 	prop: 'msgLimits', // 验证规则
          // 	labelWidth: "140px", // label 宽度
          // 	itemWidth: '100%',
          // 	max: 500000,
          // 	min: 0,
          // }],
          [{
            valueType: 'upload', // 类型
            label: '图片',
            key: 'bgUrlList', // 数据名称
            prop: 'bgUrlList',
            itemWidth: '100%',
            labelWidth: "140px", // label 宽度
            disabled: false,
            otherConfig: {
              showInfoInput: false,
              imgWidth: '100px',
              imgHeight: '80px',
              method: ['delete', 'edit']
            },
            uploadConfig: {
              accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
              uploadPath: publicApi.uploadFile,
              size: '20480kb',
              count: 1
            },
            options: {
              fileUrlKey: 'url',
              fileInfoKey: 'description',
            },
          }],
        ]
      },
      //dialog-form配置单位
      dialogVisible2: false,
      ruleForm2: {
        areaId: '',
        title: '', //主题名称
        titlePinyin:'',
        undertakeUnit: '', //承办单位
        constructionUnit: '', //建设单位
        supportUnit: '', //技术支持单位
        domain:'',//域名
        bgImg:'',//登录页图片
        indexImg:'',//首页背景图
        bgImgList: [],
        indexImgList:[]
      },
      rules2: {},
      buttonConfig2: {
        validateAll: ['editForm'],
        buttons: [{
          type: 'save', // 保存
          fn: () => {
            this.ruleForm2.bgImg = this.ruleForm2.bgImgList != 0 ? this.ruleForm2.bgImgList[0].url : "";
            this.ruleForm2.indexImg =this.ruleForm2.indexImgList != 0 ? this.ruleForm2.indexImgList[0].url : "";
            this.$http.post(districtApi.saveUnit, this.ruleForm2).then(res => {
              if (res.status === 200) {
                this.dialogVisible2 = false;
                this.ruleForm2.bgImg ="";
                this.ruleForm2.indexImg ="";
              }
            })
          },
        }, {
          type: 'back', // 返回
          fn: () => {
            this.title = '';
            this.dialogVisible2 = false;
          }
        },]
      },
      formConfig2: {
        disabled: false,
        ref: 'mapform',
        items: [
          [{
            valueType: 'input', // 类型
            label: '域名',
            key: 'domain', // 数据名称
            prop: 'domain', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入域名', // 域名
          }],
          [{
            valueType: 'input', // 类型
            label: '主题名称',
            key: 'title', // 数据名称
            prop: 'title', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入首页主题名称', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '英文名称',
            key: 'titlePinyin', // 数据名称
            prop: 'titlePinyin', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入首页主题名称', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '承办单位',
            key: 'undertakeUnit', // 数据名称
            prop: 'undertakeUnit', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入承办单位名称', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '建设单位',
            key: 'constructionUnit', // 数据名称
            prop: 'constructionUnit', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入建设单位名称', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '技术支持单位',
            key: 'supportUnit', // 数据名称
            prop: 'supportUnit', // 验证规则
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入技术支持单位名称', // 提示信息
          }],
          [{
            valueType: 'upload', // 类型
            label: '登录页图片',
            key: 'bgImgList', // 数据名称
            prop: 'bgImgList',
            itemWidth: '100%',
            labelWidth: "140px", // label 宽度
            disabled: false,
            otherConfig: {
              showInfoInput: false,
              imgWidth: '100px',
              imgHeight: '80px',
              method: ['delete', 'edit']
            },
            uploadConfig: {
              accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
              uploadPath: publicApi.uploadFile,
              size: '20480kb',
              count: 1
            },
            options: {
              fileUrlKey: 'url',
              fileInfoKey: 'description',
            },
            fn:data=>{
              console.log(data)
            }
          }],
          [{
            valueType: 'upload', // 类型
            label: '首页图片',
            key: 'indexImgList', // 数据名称
            prop: 'indexImgList',
            itemWidth: '100%',
            labelWidth: "140px", // label 宽度
            disabled: false,
            otherConfig: {
              showInfoInput: false,
              imgWidth: '100px',
              imgHeight: '80px',
              method: ['delete', 'edit']
            },
            uploadConfig: {
              accept: 'image/jpg,image/jpeg, image/png, image/tif, image/gif',
              uploadPath: publicApi.uploadFile,
              size: '20480kb',
              count: 1
            },
            options: {
              fileUrlKey: 'url',
              fileInfoKey: 'description',
            },
          }],
        ]
      },

      dialogVisible3: false,
      rules3: {},
      ruleForm3: {
        id: '',
        ip: '', //监控ip
        port: '', //监控平台地址
      },
      formConfig3: {
        disabled: false,
        items: [
          [{
            valueType: 'input', // 类型
            label: 'IP地址',
            key: 'ip', // 数据名称
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入监控平台的IP地址', // 提示信息
          }],
          [{
            valueType: 'input', // 类型
            label: '端口地址',
            key: 'port', // 数据名称
            labelWidth: "140px", // label 宽度
            itemWidth: '100%',
            maxlength: 50,
            placeholder: '请输入监控平台的端口地址', // 提示信息
          }],
        ]
      },
      buttonConfig3: {
        validateAll: ['editForm'],
        buttons: [{
          type: 'save', // 保存
          fn: (data) => {
            console.log(data)
            this.$http.post(dahuaApi.monitorAddress, this.ruleForm3).then(res => {
              if (res.status === 200) {
                this.dialogVisible3 = false;
              }
            })
          },
        }, {
          type: 'back', // 返回
          fn: () => {
            this.title = '';
            this.dialogVisible3 = false;
          }
        },]
      },
      /*------------------------------------------- 终端配置页面 start------------------------------*/
      dialogVisible4: false,
      rules4: {},
      ruleForm4: {
        id: '',
        areaId:'',//区域编号
        saveList: [], //权限
      },
      formConfig4: {
        disabled: false,
        items: [
          [
            {
              valueType: 'checkbox', // 类型
              label: '终端类型',
              key: 'saveList', // 数据名称
              prop: 'saveList', // 验证规则
              labelWidth: "140px",  // label 宽度
              itemWidth: '100%',
              options: {label: 'label',value: 'value'},
              data: [],
            }],
        ]
      },
      buttonConfig4: {
        validateAll: ['editForm'],
        buttons: [{
          type: 'save', // 保存
          fn: (data) => {
            console.log(data)
            this.$http.post(districtApi.liveIo, this.ruleForm4).then(res => {
              if (res.status === 200) {
                this.dialogVisible4 = false;
              }
            })
            this.dialogVisible4 = false;
          },
        }, {
          type: 'back', // 返回
          fn: () => {
            this.title = '';
            this.dialogVisible4 = false;
          }
        },]
      },
     /*------------------------------------------- 终端配置页面 end------------------------------*/

    }
  },
  mounted() {
    // this.setSearchParams()
  },
  methods: {
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.setSearchParams()
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page
      this.searchParams.page = page;
      this.setSearchParams()
    },
    nodeClick(node) {
      // if(node.id!==this.searchParams.areaId){
      this.searchParams.areaId = node.id;
      this.ruleForm.parentName = node.id ? node.name : "";
      this.ruleForm.parentId = node.id;
      this.searchParams.page = this.pagination.page = 1;
      this.setSearchParams();
      // }
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.tableLoading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      console.log(params);
      this.$http.get(districtApi.queryListByPage, {
        params: params
      }).then(res => {
        if (res.status === 200) {
          let result = res.result.pageList;
          result.map(item => {
            item.report = !item.report;
          })
          this.tableTemplateData = result;
          this.pagination.total = res.result.total;
          this.tableLoading = false;
        }
      })
    },
    resetCallBack() {
      this.tableLoading = true;
      let areaId = this.searchParams.areaId;
      this.searchParams = {
        open: '',
        report: '',
        page: 1,
        size: 15,
        areaId: areaId
      };
      this.searchParams.page = this.pagination.page = 1;
      this.setSearchParams();
      // this.$http.get(userApi.allUserAll, {
      // 	params: params
      // }).then(res => {
      // 	if (res.success) {
      // 		this.tableTemplateData = res.result.content
      // 		this.pagination.total = res.result.totalElements;
      //		this.tableLoading=false;
      // 	}
      // })
    },
    handleClose() {
      this.title = '';
      this.dialogVisible = false;
    },
    handleClose2() {
      this.title = '';
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.title = '';
      this.dialogVisible3 = false;
    }  ,
    handleClose4() {
      this.title = '';
      this.dialogVisible4 = false;
    }
  }
}
</script>

<style lang="less" scoped>
.regional-authorized {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;

  .regional-authorized-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;

    .plug-tree {
    }
  }

  .regional-authorized-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
